import clsx from 'clsx';
import MenuLink from "./MenuLink";
import { jsx as _jsx } from "react/jsx-runtime";
var Links = function Links(_ref) {
  var links = _ref.links,
    isSupplanting = _ref.isSupplanting;
  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (links.length == 0) return null;
  return /*#__PURE__*/_jsx("div", {
    className: clsx('tw-w-full tw-mt-0.8 tw-pt-0.8 -tw-mb-1.2', 'tw-border-solid tw-border-t dark:tw-border-t-neutral-dark-700', isSupplanting ? 'tw-border-t-neutral-dark-300' : 'tw-border-t-neutral-light-300'),
    children: links.map(function (link) {
      return /*#__PURE__*/_jsx(MenuLink, {
        link: link
      }, link.key);
    })
  });
};
export default Links;